import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'ho1a-BloqueCompetencias',
    templateUrl: './BloqueCompetencias.component.html',
    styleUrls: ['./BloqueCompetencias.component.scss']
})
export class BloqueCompetenciasComponent implements OnInit {

    @Output() clickCompetencia: EventEmitter<any>;
    @Input() competencia: any;
    @Input() competencia_activa: number;
    filespath = environment.filespath;

    constructor() {
        this.clickCompetencia = new EventEmitter();
    }

    ngOnInit() { }

    filtrar(id){
        this.clickCompetencia.emit(id);
    }

  setColor (competencia) {
    let color = 'card text-center default ';

    if (competencia.nombre === this.competencia_activa) {
        color += 'active';
      }
    switch (competencia.id_competencia) {
      case 1:
        color = 'card text-center mx-auto';
        break;
      case 2:
        color = 'card text-center mx-auto';
        break;
      case 3:
        color = 'card text-center mx-auto';
        break;
      case 4:
        color = 'card text-center mx-auto';
        break;
      default:
        color = 'card text-center mx-auto';
        break;
    }
    return color;
    }
}
